module.exports = __webpack_public_path__ + "img/no-profile.2059e301.png";